// constants.js
// BaseURL
export const BASE_URL = "http://localhost:5001/api/migpath";

// Calendly Links - PR Consultations by Country
export const CALENDLY_PR_CANADA =
  "https://calendly.com/113-notapaths/pr-consultation";
export const CALENDLY_PR_AUSTRALIA =
  "https://calendly.com/113-notapaths/pr-consultation";
export const CALENDLY_PR_NEW_ZEALAND =
  "https://calendly.com/113-notapaths/pr-consultation";
export const CALENDLY_PR_PORTUGAL =
  "https://calendly.com/113-notapaths/pr-consultation";

// Legacy - General PR Consultation (fallback)
export const CALENDLY_PR_CONSULTATION =
  "https://calendly.com/113-notapaths/pr-consultation";

// Program Intake Links
export const AUSTRALIA_CARE_WORKFORCE_INTAKE_FORM =
  "/forms/australia-care-workforce-intake";
// Australia Care Workforce intake status.
// Set to `false` while the current cohort is at capacity to pause new applications.
// Flip back to `true` when the next cohort opens.
export const AUSTRALIA_CARE_WORKFORCE_APPLICATIONS_OPEN = false;
